// Shared metadata for statuses, priorities and the 3 data concepts — monochrome palette.

export const STATUS_META = {
  planned: { label: "Planned", color: "#64748B", bg: "rgba(100,116,139,0.12)" },
  backlog: { label: "Backlog", color: "#94A3B8", bg: "rgba(148,163,184,0.12)" },
  to_do: { label: "Sprint", color: "#3B82F6", bg: "rgba(59,130,246,0.14)" },
  in_progress: { label: "In Progress", color: "#F59E0B", bg: "rgba(245,158,11,0.14)" },
  review: { label: "In Review", color: "#8B5CF6", bg: "rgba(139,92,246,0.14)" },
  done: { label: "Cleared", color: "#22C55E", bg: "rgba(34,197,94,0.14)" },
  on_hold: { label: "On Hold", color: "#DC2626", bg: "rgba(220,38,38,0.14)" },
  waiting_approval: { label: "Waiting Approval", color: "#94A3B8", bg: "rgba(148,163,184,0.14)" },
  replaced: { label: "Replaced", color: "#E2E8F0", bg: "rgba(226,232,240,0.10)" },
};

export const KANBAN_COLUMNS = [
  "backlog",
  "to_do",
  "in_progress",
  "review",
  "done",
  "on_hold",
  "waiting_approval",
  "replaced",
];

// Timeline status — dimensi terpisah dari workflow status
export const TIMELINE_STATUS_META = {
  on_track: { label: "On Track", color: "#22C55E", bg: "rgba(34,197,94,0.12)" },
  awaiting_review: { label: "Menunggu Review", color: "#FBBF24", bg: "rgba(251,191,36,0.12)" },
  late: { label: "Terlambat", color: "#F43F5E", bg: "rgba(244,63,94,0.14)" },
  no_deadline: { label: "Tanpa Deadline", color: "#94A3B8", bg: "rgba(148,163,184,0.12)" },
};

export const PRIORITY_META = {
  low: { label: "Low", color: "#B45309" },
  medium: { label: "Medium", color: "#94A3B8" },
  high: { label: "High", color: "#E2E8F0" },
  urgent: { label: "Urgent", color: "#F59E0B" },
};

// The 3 core data concepts, visually distinguished by grayscale tones
export const CONCEPT = {
  timeline: { color: "#94A3B8", bg: "rgba(148,163,184,0.12)", border: "#94A3B8" },
  weight: { color: "#F59E0B", bg: "rgba(245,158,11,0.16)", border: "#F59E0B" },
  actual: { color: "#B45309", bg: "rgba(180,83,9,0.12)", border: "#64748B" },
};

export const TASK_TYPE_META = {
  project: { label: "Project", color: "#64748B" },
  internal: { label: "Internal", color: "#94A3B8" },
  konsep: { label: "Konsep", color: "#E2E8F0" },
};
